import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { pinInsight } from 'action/insight'
import PropTypes from 'prop-types'
import confirmModal from 'view/component/confirm-modal'
import { startCase } from 'lodash'
import { Button } from 'antd'
import styles from './styles'

const generateModalText = (title, pinnedText) => ({
  decide: {
    content: '',
    title: `Are you sure you want to ${pinnedText} ${title}?`
  },

  outcome: {
    content: {
      error: 'Please try Again',
      success: `${title} has been successfully ${pinnedText}ned`
    },
    title: {
      error: `There has been an issue ${pinnedText}ning ${title}`,
      success: `Insight ${pinnedText}ned`
    }
  }
})

const PinInsight = ({ pinInsight, insight: { uuid, title, pinned: isPinned, is_draft: isDraft }, pagination }) => {
  const pinnedText = isPinned ? 'unpin' : 'pin'

  const handleSubmit = () => pinInsight(uuid)

  const { decide, outcome } = generateModalText(title, pinnedText)

  return (
    <Button
      className={styles.menu_item}
      disabled={isDraft}
      onClick={() => confirmModal(handleSubmit, decide, outcome)}
      type='text'
    >{`${startCase(pinnedText)} Insight`}</Button>
  )
}

PinInsight.propTypes = {
  insight: PropTypes.object,
  pagination: PropTypes.object,
  pinInsight: PropTypes.func
}

const mapDispatchToProps = (dispatch) => ({
  pinInsight: bindActionCreators(pinInsight, dispatch)
})

const mapStateToProps = (state) => ({
  pagination: state.insight.pagination
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PinInsight)
